module.exports = __webpack_public_path__ + "img/fig9.18.5bcb33ce.png";